// ================================================================
// config.ts — Runtime platform configuration
// 讓管理者在 UI 輸入 Entra App Registration 資訊
// 儲存於 localStorage，不需在 build 時寫死
// ================================================================

export interface PlatformConfig {
  loginClientId: string;   // Login App Registration Client ID
  tenantId:      string;   // 'common'（multi-tenant）或特定 tenant GUID
  redirectUri:   string;   // 通常是 window.location.origin + '/auth/callback'
}

const STORAGE_KEY = 'ai_platform_config';

// build-time 設定（平台方於 .env.production 烘入）。多租戶 SaaS 首選來源，
// 讓新客戶直接進登入頁、不需 SetupWizard。localStorage 僅作為手動覆寫。
function buildTimeConfig(): PlatformConfig | null {
  const loginClientId = import.meta.env.VITE_LOGIN_CLIENT_ID as string | undefined;
  if (!loginClientId) return null;
  return {
    loginClientId,
    tenantId:    (import.meta.env.VITE_TENANT_ID as string) || 'common',  // 多租戶預設 common
    redirectUri: (import.meta.env.VITE_REDIRECT_URI as string) || defaultRedirectUri(),
  };
}

export function getConfig(): PlatformConfig | null {
  // 1) localStorage 覆寫（進階/BYO）
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as PlatformConfig;
      if (parsed.loginClientId && parsed.tenantId && parsed.redirectUri) return parsed;
    }
  } catch { /* ignore */ }
  // 2) build-time 平台設定（多租戶 SaaS 主路徑）
  return buildTimeConfig();
}

export function saveConfig(cfg: PlatformConfig): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(cfg));
}

export function clearConfig(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function defaultRedirectUri(): string {
  return window.location.origin + '/auth/callback';
}
